<template>
  <div class="project" :class="{'project-mobile' : isMobile == 'mobile'}">
    <div>
      <el-row :gutter="20" type="flex" style="flex-wrap:wrap">
        <el-col :span="screenWidth <= 540?12:8" v-for="item in list" :key="item.id">
          <div class="project-list" @click="toJump(item.title,item.id)">
            <div>
              <img :src="item.imgUrl" alt="" width="100%" class="founding-img-list-item" style="object-fit:cover;"  >
            </div>
            <div style="padding: 1rem 1rem;" v-if="isMobile == 'pc'">
              <h3 class="project-list-title">{{item.name}}</h3>
              <div style="overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 4;-webkit-box-orient: vertical;line-height: 2;">{{ item.content }}</div>
              <div style="text-align: right;margin:1rem;cursor: pointer;">
                {{$t('ViewDetails')}} <i class="el-icon-right"></i>
              </div>
            </div>
            <!-- 移动端 -->
            <div style="padding: 1rem 1rem;" v-if="isMobile == 'mobile'">
              <h3 class="project-list-title">{{item.name}}</h3>
                <div style="overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 4;-webkit-box-orient: vertical;line-height: 2;">{{ item.content }}</div>
                <div style="text-align: right;margin:1rem;cursor: pointer;">
                  {{$t('ViewDetails')}} <i class="el-icon-right"></i>
                </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- <div style="width: 100%;text-align: center;font-size: 1.5rem;margin-top:2rem" v-if="loading">
      <i class="el-icon-loading"></i>
    </div> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { listSpecFund } from '@/api/index';
export default {
  computed: {
    ...mapState(['screenWidth']),
    isMobile() {
        const userAgentInfo = navigator.userAgent;
        const agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
        for (let i = 0; i < agents.length; i++) {
            if (userAgentInfo.indexOf(agents[i]) > -1) {
                return 'mobile'; // 移动端
            }
        }
        return 'pc'; // PC端
    }
  },
  data() {
    return {
      list: [],
      title: "",
      page: 1,
      loading: false
    };
  },
  mounted() {
    const meta = document.createElement('meta');
    meta.setAttribute('name', 'referrer');
    meta.setAttribute('content', 'never');
    document.head.appendChild(meta);

    this.title = this.$route.query.search;
    this.listSpecFunds(1)
  },
  methods: {
    toJump(title,id) {
      this.$router.push({
        path: '/foundationProject/sectorList',
        query: {
          title: title,
          id: id,
        },
      });
    },
    // scrolling() {
    //   // scrollTop是滚动条滚动时，距离顶部的距离
    //   let scrollTop = document.documentElement.scrollTop
    //   // windowHeight是可视区的高度
    //   let windowHeight = document.documentElement.clientHeight
    //   // scrollHeight是滚动条的总高度
    //   let scrollHeight = document.documentElement.scrollHeight
    //   let bottom = scrollHeight - scrollTop - windowHeight;
      
    //   if (!this.loading && bottom < 150 && this.page < this.totalPage) {
    //     this.page++
    //     this.loading = true
    //     setTimeout(() => {
    //       this.listSpecFunds(this.page)
    //     }, 10);

    //   }
    // },
    async listSpecFunds(page, size, title) {
      let res = await listSpecFund({
        "type": 1,
        "page": page || 1,
        "size": 100
      })
      if (res.data && res.data != null) {
        this.list = res.data.records
      }



      // let res = await listSpecFund({
      //   "type": 1,
      //   "page": page,
      //   "size": 10
      // })
      // if (res.data && res.data != null) {
      //   if (page == 1) {
      //     this.list = res.data.records
      //   } else {
      //     this.list = [...this.list, ...res.data.records]
      //   }
      //   this.loading = false
      //   this.totalPage = res.data.pages
      // }
    },
  },
};
</script>

<style lang="less" scoped>
.project {
  padding: 2rem 10%;
  padding-top: 0;
  background-color: #ffffff;
  width: 80%;
  .project-list {
    width: 100%;
    background-color: #f6f6f6;
    border-radius: 0.5rem;
    overflow: hidden;
    margin-top: 2rem;
  }
}
.project-mobile{
  padding: 2rem 18px !important;
  width:91%!important;

}
a {
  text-decoration: none;
  color: black;
}
.project-list-title{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.founding-img-list-item{
  height: 15rem;
}
</style>